import { createContext, useContext } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setPage } from "../../store/reducers/users/users.reducer";
import { getUsersThunk } from "../../store/reducers/users/users.thunks";

const UsersPaginationContext = createContext(null);

export const UsersPaginationProvider = ({ children }) => {
  const dispatch = useDispatch();

  const { page, totalPages } = useSelector((state) => state.users);
//   console.log(totalPages);
  const goToPage = (newPage) => {
    if (newPage < 1 || newPage > totalPages) return;

    dispatch(setPage(newPage));
    dispatch(getUsersThunk(newPage));
  };

  return (
    <UsersPaginationContext.Provider value={{ page, totalPages, goToPage }}>
      {children}
    </UsersPaginationContext.Provider>
  );
};

export const useUsersPagination = () => {
  return useContext(UsersPaginationContext);
};
